import Hero from './sections/Hero'
import Features from './sections/Features'
import Stats from './sections/Stats'
import CTA from './sections/CTA'

const Home = () => {
  return (
    <div>
      <Hero />
      <Features />
      <Stats />
      <CTA />
    </div>
  )
}

export default Home

